// extracted by css-extract-rspack-plugin
export default {"carousel":"_c7654437"};